export const formatDate = (value: Date | string) => {
  return typeof value === 'string'
    ? ''
    : value.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
};

export const formatDateTime = (value: Date | string) => {
  return typeof value === 'string'
    ? ''
    : value.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
};

export const makeDate = (value: string) => {
  return value === null || value === '0001-01-01T00:00:00' ? '' : new Date(value);
};

// Serialises a Date as a timezone-free local date string (`YYYY-MM-DDT00:00:00`).
// Deliberately not `toISOString()`, which converts to UTC and can shift a local
// midnight back a day for any UTC+ timezone (e.g. CET 2026-09-01 00:00 -> 2026-08-31T22:00:00Z).
// See docs/adr/0007-accommodation-blocking-date-only-serialisation.md.
export const toApiDate = (value: Date) => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00`;
};

export const makeStatus = (value: number) => {
  switch (value) {
    case 0: {
      return 'OK';
    }
    case 1: {
      return 'Warning';
    }
    case 2: {
      return 'Error';
    }
    default: {
      return 'No status';
    }
  }
};

export const makeBookability = (value: number) => {
  switch (value) {
    case 0: {
      return 'Yes';
    }
    default: {
      return 'No';
    }
  }
};
